import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { EXCEL_CELL_ERROR_LABEL, FORM_TEMPLATE_CELL_ERROR_LABEL } from '@/helpers/enums/params'


export const createBTextFieldAteModal = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BTextFieldAteModal" */
    './Modals/LKTextFieldAteFormdataStartedModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export function FixClusterize(Clusterize) {
  // eslint-disable-next-line no-param-reassign
  Clusterize.prototype.getClusterNum = function getClusterNum() {
    this.options.scroll_top = this.scroll_elem.scrollTop
    return Math.floor(this.options.scroll_top / this.options.cluster_height) || 0
  }

  // eslint-disable-next-line no-param-reassign
  Clusterize.prototype.generate = function generate(rows, cluster_num) {
    const opts = this.options
    const rows_len = rows.length

    if (rows_len < opts.rows_in_block) {
      return {
        top_offset: 0, bottom_offset: 0, rows_above: 0, rows: rows_len ? rows : this.generateEmptyRow(),
      }
    }
    const rows_in_scroll = Math.ceil(this.scroll_elem.offsetHeight / opts.item_height)
    const rows_in_beetween = Math.max(opts.rows_in_block, rows_in_scroll)
    const items_start = Math.max(opts.rows_in_cluster * cluster_num, 0)
    const items_end = items_start + opts.rows_in_cluster
    const top_offset = Math.max((items_start - rows_in_beetween) * opts.item_height, 0)
    const bottom_offset = Math.max((rows_len - items_end - 1) * opts.item_height, 0)
    const this_cluster_rows = []
    let rows_above = items_start
    if (top_offset < 1) rows_above += 1
    for (let i = Math.max(items_start - rows_in_beetween, 0); i < items_end + rows_in_beetween; i += 1) {
      if (rows[i]) {
        this_cluster_rows.push(rows[i])
      }
    }
    return {
      top_offset, bottom_offset, rows_above, rows: this_cluster_rows,
    }
  }
}

export function evaluateFormula(formula) {
  if (formula.includes(EXCEL_CELL_ERROR_LABEL)) return EXCEL_CELL_ERROR_LABEL

  // eslint-disable-next-line no-new-func
  const value = new Function(`return (${formula})`)()

  if (!Number.isFinite(value) || Number.isNaN(value)) return FORM_TEMPLATE_CELL_ERROR_LABEL

  return value
}
